var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tw-bg-gray-200 tw-animate-pulse tw-rounded"})
}
var staticRenderFns = []

export { render, staticRenderFns }